import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const enumWordOverrides: Record<string, string> = {
  ai: 'AI',
  api: 'API',
  id: 'ID',
  rsvp: 'RSVP',
  sms: 'SMS',
  url: 'URL',
};

function capitalizeWord(word: string) {
  const normalizedWord = word.toLowerCase();

  return (
    enumWordOverrides[normalizedWord] ??
    `${normalizedWord.charAt(0).toUpperCase()}${normalizedWord.slice(1)}`
  );
}

export function formatEnumLabel(
  value: string | null | undefined,
  overrides: Record<string, string> = {},
) {
  if (!value) {
    return '';
  }

  return (overrides[value] ?? value)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .split(/[_\-\s]+/)
    .filter(Boolean)
    .map((word) => capitalizeWord(word))
    .join(' ');
}
